// TODO: this will need to account for cases where two people are assinged to the same turf and repeat that dropoff step for them,
// b/c the backend calculations will work like that.

// necessary url params for building crewsheet are ?office=1&crewcanvassers=1|2|3

// THE door screen will need to do a call to both get the order of the turfs and then to get the driving directions.

import React, { Component } from "react";

import api from "../../store/api/api";
import { get as _get, lowerCase } from "lodash";
import "../../styles/crewSheet.scss";
import { connect } from "react-redux";
import moment from "moment";
import FullScreenSpinner from "../theme/loaders/FullScreenSpinner";
import BasicPointMap from "../maps/BasicPointMap";
import CrewSheetDrivingDirections from "../crewsheets/DrivingDirections";
import MapsLinks from "../crewsheets/MapsLinks";
import { AvailRoleToken } from "../cards/DraggableShiftCanvasser";
import { withRouter} from "../../utils/withRouter";

class PageBreak extends Component {
  render = () => <div style={{ pageBreakAfter: "always" }} />;
}

class SiteCrewSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buffer_time: 10,
      time_in_office: 20,
    };
  }

  //A few things you can trust about the data: if there is a driver, it will always be last in the canvasser array.
  //CAnvassers also come sorted in the order that they should be dropped off.

  buildCanvasserRows(config) {
    let { time_goals } = config;

    const showDebug = document.location.search.indexOf("debug=true") > -1;

    let table_rows = this.props.crew.canvassers.map((canvasser, idx) => {
      console.log(canvasser);
      return (
        <tr>
          <td className="name">
            <b>
              {canvasser.firstname} {canvasser.lastname}
            </b>
            <br />
            {canvasser.assigned_roles.map((d) => d.type_name).join(", ")} <br />
            * <br />
            {canvasser.abilities &&
              canvasser.abilities.map((d) => (
                <AvailRoleToken role={d.type_name} key={d.id} />
              ))}
            <br />
            {canvasser.work_phone}
            <br />
            {canvasser.personal_phone}
            <br />
          </td>
          <td className="canvasser-goal">{canvasser.goal}</td>
          <td className="sites">
            {canvasser.sites.map((d, i, a) => (
              <div>
                {a.length > 1 ? i + 1 + ")" : ""} {d.name}{" "}
                <span style={{ color: "#606c76", fontStyle: "italic" }}>
                  ({d.addressline1}, {d.city})
                </span>
              </div>
            ))}
          </td>
          <td className="comments">{canvasser.comments}</td>

          <td className="info">
            <div className="empty-space">
              {time_goals[idx].dropoff.format("h:mma")} /{" "}
              {time_goals[idx].pickup.format("h:mma")}
              {showDebug && (
                <span>
                  {" "}
                  (
                  {Math.round(
                    this.props.crew.directions.legs[idx].duration / 60
                  )}{" "}
                  minutes
                </span>
              )}
            </div>
          </td>
          <td className="info">
            <div className="empty-space"></div>
          </td>
          {/*<td className="notes">*/}
          {/*    <div className="empty-space"></div>*/}
          {/*</td>*/}
        </tr>
      );
    });

    return table_rows;
  }

  getTimeGoals() {
    const { date, end_time, start_time } = this.props.crew.shift;
    //calculated time we leave so that canvassers can waste time and do things in the office

    let startMoment = new moment(`${date}T${start_time}`);
    let endMoment = new moment(`${date}T${end_time}`);

    if (!startMoment.isValid()) {
      console.warn("USING DEFAULT 9am START TIME");
      startMoment = new moment().hour(9).minute(0).second(0);
    }

    if (!endMoment.isValid()) {
      console.warn("USING DEFAULT 5pm END TIME");
      endMoment = new moment().hour(17).minute(0).second(0);
    }

    console.log("GOALS BASED ON START/END: ", startMoment, endMoment);

    let dropoff = startMoment.add(
      this.state.buffer_time + this.state.time_in_office,
      "minutes"
    );

    let dropoff_pickup_times = [];
    this.props.crew.directions.legs.forEach((leg, i) => {
      dropoff.add(leg.duration, "seconds");
      dropoff_pickup_times[i] = { dropoff: dropoff.clone() };

      let drive_time = this.props.crew.directions.legs
        .slice(0, i)
        .reduce((acc, val) => {
          return acc + val.duration;
        }, this.state.time_in_office * 60);

      let pickup = endMoment.clone().subtract(drive_time, "seconds");

      dropoff_pickup_times[i].pickup = pickup;
    });

    return dropoff_pickup_times;
  }

  renderMaps() {
    let canvassers = this.props.crew.canvassers;
    let all_points = [];
    // if (this.props. crew.)

    let canvasserGroup = 0;
    canvassers.forEach((canvasser) => {
      let canvasser_points = canvasser.sites
        .map((d, i) => {
          let is_dropoff = d.id && d.id === canvasser.dropoff.id;
          return {
            ...d,
            lat: +d.latitude,
            lon: +d.longitude,
            color: canvasser.color,
            radius: is_dropoff ? 10 : null,
            is_dropoff: is_dropoff,
            name: is_dropoff ? canvasser.initials.toUpperCase() + " DROP" : "",
            group: canvasserGroup,
          };
        })
        .sort((a, b) => (a.is_dropoff ? 1 : -1)); // dropoff points rendered last and on top
      all_points = [...all_points, ...canvasser_points];
    });

    if (this.props.crew.route_to_all_sites)
      all_points = all_points.map((d) => ({ ...d, color: "red" }));

    let polyline = _get(this.props, "crew.directions.geometry", null);
    if (this.props.sessionVars.hideTravelPaths) polyline = null;

    //INDIVIDUAL MAPS DISABLED FOR SITES

    // crew wide map
    return (
      <>
        <div className={"crewsheet-individual-map"}>
          <h5>Crew Map</h5>
          <BasicPointMap
            features={all_points}
            target={"crew-map-" + this.props.crew.id} // name of div id to bind to
            polyline={polyline}
          />
        </div>
        <PageBreak />
      </>
    );
  }

  render() {
    const showDebug = document.location.search.indexOf("debug=true") > -1;
    let dropoff_pickup_times = this.getTimeGoals();

    let rows = this.buildCanvasserRows({ time_goals: dropoff_pickup_times });
    let canvassers = _get(this.props, "crew.canvassers", []);

    let driver =
      canvassers.find((d) =>
        d.assigned_roles.map((r) => lowerCase(r.type_name)).includes("driver")
      ) || {};
    let teamLeader =
      canvassers.find((d) =>
        d.assigned_roles
          .map((r) => lowerCase(r.type_name))
          .includes("team leader")
      ) || {};

    return (
      <div className="crewsheet-container">
        <div className={"flx space_between crewsheet-header"}>
          <span>Crew {this.props.crew.id}</span>
          <span>{this.props.crew.canvassers[0].date}</span>
        </div>
        <div>
          <table className="crew-goal invisible-row">
            People
            <tbody>
              <tr>
                <td style={{ backgroundColor: "#c2c3c4" }}>Team Leader</td>
                <td>Driver</td>
              </tr>
              <tr>
                <td>
                  <b>
                    {teamLeader.firstname} {teamLeader.lastname}
                  </b>
                </td>
                <td>
                  {driver.firstname} {driver.lastname}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="crew-goal space-table invisible-row">
            <thead>
              <tr>Crew Goal</tr>
            </thead>
            <tbody>
              <tr>
                <td>Goal</td>
                <td>Actual</td>
              </tr>
              <tr>
                <td>
                  {this.props.crew.canvassers.reduce(
                    (r, d) => (r += d.goal),
                    0
                  )}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table className="crew-goal space-table">
            <thead>
              <tr>
                Driver Times{" "}
                {showDebug && (
                  <em>
                    ({this.props.crew.shift.start_time} -{" "}
                    {this.props.crew.shift.end_time})
                  </em>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Goal</td>
                <td>Actual</td>
                <td>In The Field Time</td>
              </tr>
              <tr>
                <td>{dropoff_pickup_times[0].dropoff.format("h:mma")}</td>
                <td></td>
                <td>First Drop Off</td>
              </tr>
              <tr>
                <td>{dropoff_pickup_times[0].pickup.format("h:mma")}</td>
                <td></td>
                <td>Last Pickup</td>
              </tr>
            </tbody>
          </table>
        </div>
        <table className="crewsheet">
          <thead>
            <tr>
              <th className="name">Name/Phones</th>
              <th className="canvasser-goal">Goal</th>
              <th className="sites">Sites</th>
              <th className="comments">Comments</th>
              <th className="info">Goal DO/PU</th>
              <th className="info">Actual DO/PU</th>
              {/*<th className="notes">Notes</th>*/}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
        <MapsLinks crew={this.props.crew} />
        {!this.props.sessionVars.hideDrivingDirections && (
          <CrewSheetDrivingDirections crew={this.props.crew} />
        )}
        <PageBreak />
        {this.renderMaps()}
      </div>
    );
  }
}

/*
 * DoorCrewSheetHoc (Higher Order Component) is responsible for retrieving data and making sure that the visual components have the data
 * they need before printing.
 *
 * */
class SiteCrewSheetHoc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      data: null,
    };
  }

  componentDidMount() {
    const shift = _get(this.props, "params.shift", 0);
    const urlParams = new URL(document.location).searchParams;
    const nocache = urlParams.get("nocache");

    const params = { shift };
    if (nocache) params.nocache = nocache;

    api
      .get("site-crewsheet/", params)
      .then((res) => {
        this.pullCrewsFromHashes({
          pullImmediately: res.data.ready,
          hashkeys: res.data.hashkeys,
        });
      })
      .catch(() => {
        this.setState({ error: true, loading: false });
      });
  }

  pullCrewsFromHashes = (config = { pullImmediately: false, hashkeys: [] }) => {
    const pullTimeout = 6000;
    const maxRetries = 20;
    let retryCount = 0;
    console.log("pull check", config);

    const pull = () =>
      api
        .post("/crewsheetbuild/", { hashkeys: config.hashkeys })
        .then((res) => {
          if (res.data.ready) {
            let crews;
            if (config.hashkeys.length === 1) {
              crews = [res.data]; //single crews are returned as an objects
            } else {
              crews = res.data.crews;
            }

            //assign colors
            crews.forEach((c) => {
              (c.canvassers || []).forEach((d, i) => {
                d.color = _get(c, "siteroute.hex_color", "#000"); // assignColorOnOrdinalScale(i)
              });
            });

            this.setState({ data: crews, crewLoadReady: true, loading: false });
          } else {
            retryCount++;
            if (retryCount >= maxRetries) {
              console.error(`Crew sheet build timed out after ${maxRetries} retries`);
              this.setState({ error: true, loading: false });
            } else {
              setTimeout(pull, pullTimeout);
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.setState({ error: true, loading: false });
        });

    setTimeout(pull, config.pullImmediately ? 0 : pullTimeout);
  };

  renderCrews() {
    return this.state.data.map((crew) => {
      if (_get(this.props, "sessionVars.excludedCrews", []).includes(crew.id)) {
        return null;
      }
      return (
        <div key={crew.id} className="crewsheet-crew-block">
          <SiteCrewSheet crew={crew} {...this.props} />
        </div>
      );
    });
  }

  render() {
    if (this.state.loading) {
      return <FullScreenSpinner />;
    } else if (this.state.error) {
      return (
        <div className={"full_screen_fixed__modal full_screen_fixed__wrapper"}>
          <p style={{ fontSize: "24px", color: "red" }}>
            There was an error building this crewsheet.
          </p>
        </div>
      );
    } else {
      return (
        <div id="crewsheet-wrapper">
          <div className={"no-print"}>
            <button
              className={"primary"}
              style={{
                fontSize: "1.4em",
                width: "30vw",
                margin: "1em",
                float: "right",
              }}
              onClick={window.print}
            >
              Print
            </button>
          </div>
          {this.renderCrews()}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  sessionVars: state.session.vars,
});

export default connect(mapStateToProps)(withRouter(SiteCrewSheetHoc));
